export const HOTEL_REQUEST = "HOTEL_REQUEST";
export const HOTEL_FAILURE = "HOTEL_FAILURE";

export const GET_HOTEL_SUCCESS = "GET_HOTEL_SUCCESS";
export const POST_HOTEL_SUCCESS = "POST_HOTEL_SUCCESS";

export const NEW_GET_HOTELS_SUCCESS = "NEW_GET_HOTELS_SUCCESS";
export const DELETE_HOTEL = "DELETE_HOTEL";
